/* eslint-disable no-unused-vars */
// LQC-2254 - load state for reference data that is fetched once, on demand, when a
// widget that needs it mounts (portfolios, bond securities). Idle means nothing has
// asked for it yet, which is the normal state for a user who never adds the widget.
export enum ReferenceDataStatus {
  Idle = "Idle",
  Loading = "Loading",
  Loaded = "Loaded",
  Error = "Error",
}
